import React from "react";
import cx from "classnames";
import { ProductCard } from "src/components/collection/product-card";

import * as styles from "./related-products.module.css";

export const RelatedProducts = ({ products }) => {
  return (
    <div className={styles.relatedProducts}>
      <h3 className={styles.label}>
        <span className="label-italic">related jewels</span>
        <span className="label-caps">From our collection</span>
      </h3>
      <div className={styles.grid}>
        {products &&
          products.map((product) => (
            <div
              key={product._id}
              className={cx(
                styles.gridItem,
                products.length === 1 ? styles.solo : ""
              )}
            >
              <ProductCard product={product} />
            </div>
          ))}
      </div>
    </div>
  );
};
